import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '@/features/auth';
import { callReducer } from '@/features/calls';
import { dashboardReducer } from '@/features/dashboard';
import { settingsReducer } from '@/features/settings';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    settings: settingsReducer,
    call: callReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
